module.exports = __webpack_public_path__ + "static/media/referee.b9d28a9f.svg";